interface StatusChipProps {
  readonly label: string;
  readonly tone?: "ready" | "quiet" | "warning";
}

export function StatusChip({ label, tone = "quiet" }: StatusChipProps) {
  return <span className={`status-chip ${tone}`}>{label}</span>;
}
